import * as React from "react";
import DiscountAnnoucement from "../../../assets/images/discount-announcement.png";

const Announcement = () => {
  const onClickAnouncement = () =>
    window.open("https://ibicare.bonda.com/", "_blank");

  return (
    <div className="d-flex announcement" onClick={onClickAnouncement}>
      <img
        src={DiscountAnnoucement}
        alt="discount-announcement"
        loading="lazy"
        style={{ borderTopRightRadius: "15px", borderTopLeftRadius: "15px" }}
      />

      <span style={{ padding: "1.25rem" }}>
        <strong>Beneficios exclusivos</strong> en miles de establecimientos,
        además de actividades y talleres <strong>totalmente gratuitos</strong>{" "}
        para mejorar tu bienestar.
      </span>
    </div>
  );
};

export default Announcement;
